import { type DesignSchemaType } from '../middlewares/PhotonRequest';
import { createContext, useContext } from 'react';

interface SchemaBase {
  schema: DesignSchemaType;
}

const SchemaContext = createContext<SchemaBase>({} as unknown as SchemaBase);

type SchemaProp = {
  children: JSX.Element;
} & SchemaBase;

export const DesignSchemaProvider = ({
  children,
  schema,
}: SchemaProp): JSX.Element => {
  const value = {
    schema,
  };
  return (
    <SchemaContext.Provider value={value}>{children}</SchemaContext.Provider>
  );
};

export const useDesignSchema = (): DesignSchemaType => {
  const { schema } = useContext(SchemaContext);
  return schema || {};
};
